<template>
  <NuxtLayout>
    <div class="container flex justify-center">
      <div class="ErrorContainer w-full flex flex-col text-center mt-18 lg:rounded-2xl lg:bg-eo-surface-default lg:p-16">
        <img
          :src="logos.withText"
          class="mb-8 h-8"
        >
        <div
          class="ErrorContainer__errorCode font-semibold mb-8"
          data-test="error-code"
        >
          {{ error.statusCode }}
        </div>
        <p class="mb-8">
          <template v-if="errorParts.length === 1">
            {{ $t(errorPost) }}
          </template>
          <template v-else>
            <span>{{ errorParts[0] }}</span>
            <TextLink to="/">
              {{ $t(11) }}
            </TextLink>
            <span>{{ errorParts[1] }}</span>
          </template>
        </p>
        <NuxtLink :href="config.ecoHome">
          www.ecoonline.com
        </NuxtLink>
      </div>
    </div>
  </NuxtLayout>
</template>

<script>
import { mapState, mapWritableState } from 'pinia'
import { useStore } from '@/store'

export default {
  props: {
    error: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(useStore, ['logos', 'config']),
    ...mapWritableState(useStore, ['breadcrumbs']),
    errorPost () {
      const { statusCode } = this.error
      if (statusCode === 404) return '10'
      if (statusCode === 401) return '22'
      return '14'
    },
    /*
      We should be able to use <i18n-t> for component interpolation,
      but it's not currently working in production with the Beta version of @nuxtjs/i18n.
    */
    errorParts () {
      const message = this.$t(this.errorPost, { homepage: '{homepage}' })
      return message.split('{homepage}')
    }
  },
  mounted () {
    this.breadcrumbs = ([{ title: String(this.error.statusCode) }])
  }
}
</script>

<style lang="postcss" scoped>
.ErrorContainer {
  max-width: 45rem;
}

.ErrorContainer__errorCode {
  font-size: 92px;
}
</style>
